var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Breadcrumbs',{attrs:{"breadcrumbs":[
      { title: this.$t(`menu.${_vm.serviceSlug}`), disabled: true },
      { title: _vm.$t('virtual_waiting_room.pages.active_users'), disabled: true }
    ]}},[_c('div',{staticClass:"d-flex align-items-center",attrs:{"slot":"breadcrumbAfter"},slot:"breadcrumbAfter"})]),_c('div',[_c('div',{staticClass:"row buttonSpace"},[_c('div',{staticClass:"col-12"},[_c('TableView',{ref:"tableView",attrs:{"service-slug":_vm.serviceSlug}})],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }